// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-calendar/dist/Calendar.css
 ** module id = 390
 ** module chunks = 0
 **/